import {gql} from "@apollo/client";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";
import {ConfirmAnticipatedDischargeInputForm} from "./ConfirmedDischargeDateModal";
import {format} from "date-fns-tz";
import {LOCAL_DATE_FORMAT} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAnticipatedDischargeDates($input: AnticipatedDischargeDatesSubmitPayloadInput) {
    submitAnticipatedDischargeDates(input: $input)
}`;

const sanitizePayload = (formValues: ConfirmAnticipatedDischargeInputForm) => {
    const inputs = formValues.inputs.map((item) => ({
        sfId: item.sfId,
        clientSfId: item.clientSfId,
        caseSfId: item.caseSfId,
        submittedAnticipatedDischargeDate: format(new Date(item.submittedAnticipatedDischargeDate), LOCAL_DATE_FORMAT),
        clinicalRationale: formValues.action === 'update' ? item.clinicalRationale : undefined,
    }))

    return {
        action: formValues.action,
        newAnticipatedDischargeDateDefined: formValues.newAnticipatedDischargeDateDefined,
        inputs: inputs,
    }
}


export function useAuthAnticipatedDischargeDate$() {
    const {execute,} = useMutation$<{ input: Object }, void>(GRAPHQL_MUTATION);
    const submitAuthAnticipatedDischargeDate = useCallback(async function (formValues: ConfirmAnticipatedDischargeInputForm | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: sanitizePayload(formValues),
                }
            });
            if (formValues.action === 'confirm') {
                showToast.success('Thank you for confirming. When submitting discharge report confirm all necessary follow-up actions are planned, documented and communicated effectively.');
            } else {
                showToast.success('Thank you for confirming. At the next progress reporting, please include a clinical rationale explaining the medical necessity for extending the anticipated discharge date.');
            }
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [execute]);

    return {
        submitAuthAnticipatedDischargeDate
    }
}
